import React,{useContext} from 'react';
import styles from "../css/Navbar.module.css";
import { Link } from "react-router-dom";
import userProfile from "../image/userprofile.svg";
import UserContext from '../context/users/UserContext';

function LogoutComp(props) {
    const context=useContext(UserContext);
    return (
        <div className={styles.userbox}>
            <Link to="/dashboard/myaccount" className={styles.afterlogin}>
            <img src={userProfile} alt="user profile" height="30px" width="30px"/>
            <span>{context.userDetails.name?context.userDetails.name:undefined}</span>
            </Link>
            <Link className={styles.signinbtn} to="/logout">
            Log Out
            </Link>
        </div>
    );
}

export default LogoutComp;